import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/about';
import Container from '../../containers/app';
import Root from '../../components/root';

export default function PageAbout() {
  return (
    <Root title={PAGE_TITLE.ABOUT}>
      <Container>
        <Component/>
      </Container>
    </Root>
  );
};
